import { render, staticRenderFns } from "./TopLeftMenu.vue?vue&type=template&id=d5b4b1a6&"
import script from "./TopLeftMenu.vue?vue&type=script&lang=ts&"
export * from "./TopLeftMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports